import { tv } from "../../../variants/tv.js";
const thVariants = tv({
    base: 'text-body2 text-neutral-10 border-b-1 border-primary-5 whitespace-nowrap text-nowrap bg-inherit p-3',
    variants: {
        sort: {
            disabled: '',
            unsorted: 'cursor-pointer',
            ascending: 'cursor-pointer',
            descending: 'cursor-pointer'
        },
        interactive: {
            true: 'hover:text-neutral-11 hover:bg-neutral-2 active:bg-neutral-4',
            false: ''
        },
        firstColumnSticky: {
            true: 'first:z-1 first:border-l-1 border-r-1 border-primary-5 first:sticky first:left-0'
        },
        tableBordered: {
            true: '',
            false: ''
        }
    },
    compoundVariants: [
        {
            firstColumnSticky: true,
            tableBordered: true,
            class: 'first:border-l-0 last:border-r-0'
        },
        {
            firstColumnSticky: true,
            tableBordered: false,
            class: 'border-t-1'
        }
    ],
    defaultVariants: {
        interactive: false,
        firstColumnSticky: false,
        tableBordered: false
    }
});
const contentVariants = tv({
    base: 'flex w-full gap-2',
    variants: {
        align: {
            left: 'justify-left',
            center: 'justify-center',
            right: 'justify-end'
        }
    },
    defaultVariants: {
        align: 'left'
    }
});
export { contentVariants, thVariants };
